import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from '@reach/router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ArrowNext } from '..';
import { MenuItem } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { commands } from '../../constants';
import { WS_ACTION_TYPES } from '../../redux-saga/actionTypes';
import theme from '../../theme/theme';
import styles from './styles';

const {
  Icons: { general },
} = theme;

const { routePreviewCommand } = commands;

const FastRouteSelector = ({ classes, t, route, sendMessageToSocket }) => {
  const onHandleClick = () => {
    sendMessageToSocket(routePreviewCommand);
    navigate('fast-route');
  };

  return (
    <React.Fragment>
      <MenuItem onClick={onHandleClick} className={classes.container}>
        <img src={general.Direction} className={classes.icon} alt="Direction" />
        {route === undefined ? (
          <Typography className={classes.title}>{t('poi-details.label.fast-route')}</Typography>
        ) : (
          <Typography className={classes.title}>{route.summary}</Typography>
        )}
        <ArrowNext />
      </MenuItem>
    </React.Fragment>
  );
};

FastRouteSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  route: PropTypes.object,
  sendMessageToSocket: PropTypes.func.isRequired,
};

FastRouteSelector.defaultProps = {
  route: {},
};

const mapStateToProps = ({ poi }) => ({
  route: poi.route,
});

const mapDispatchToProps = dispatch => ({
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(FastRouteSelector)),
);
